import styled from "styled-components";
export const DetialComponent = styled.div`
  padding: 32px 0;
  .side {
    background: #fff;
    border-radius: 10px;
    border: solid 1px ${({ theme }) => theme.colors.btnPrimaryBg};
    overflow: hidden;
    .image {
      img {
        width: 100%;
      }
    }
    .content {
      padding: 8px;
      .labels {
        display: flex;
        margin-bottom: 16px;
        span {
          font-size: 12px;
          font-weight: 500;
          padding: 6px 16px 2px 16px;
        }
      }
      .amount {
        background: ${({ theme }) => theme.colors.btnPrimaryBg};
        width: calc(100% + 16px);
        text-align: center;
        padding: 16px 6px 8px 6px;
        margin: 32px -8px -9px -8px;
        color: #fff;
      }
      .grey-item {
        border-bottom: solid 1px ${({ theme }) => theme.colors.btnPrimaryBg};
        width: 100%;
        text-align: center;
        padding: 10px 6px 4px 6px;
        margin-bottom: 8px;
        .value{
          font-size:0.8em;
        }
      }
      textarea {
        height: 180px;
        resize: none;
      }
      button {
        width: 100%;
      }
    }
  }
  .buttons {
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    direction: rtl;
  }
  @media only screen and (max-width: 760px) {
    padding: 32px 0;
    .side {
      margin-bottom: 32px;
      .content {
        .green-item {
          padding: 10px 6px 6px 6px;
        }
        .grey-item {
          padding: 10px 6px 6px 6px;
        }
      }
      .desk-back {
        display: none;
      }
    }
  }
`;
